module.exports = __webpack_public_path__ + "img/9.72d9081c.webp";